// extracted by mini-css-extract-plugin
module.exports = {"title":"styles_title__a8TD_","text_blurb":"styles_text_blurb__3fuI3"};